import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9b7c3f88"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "py-2 px-3 flex flex-col chat-window-content" };
const _hoisted_2 = { class: "flex flex-row gap-2 text-gray-400" };
import { appState } from '@/composable/appState';
import { ChatType } from '@/helper/const';
import { UICollapse, UICollapseItem, UIDivider, UITag, UITextXsRegular, } from '@gohighlevel/ghl-ui';
import AdditionalOptions from './ChatWindow/AdditionalOptions.vue';
import BusinessOfficeHourSetup from './ChatWindow/BusinessOfficeHourSetup.vue';
import LiveChatAssigned from './ChatWindow/LiveChatAssigned.vue';
import LiveChatClosed from './ChatWindow/LiveChatClosed.vue';
import TitleAndIntro from './ChatWindow/TitleAndIntro.vue';
import WhatsappSettings from './ChatWindow/WhatsappSettings.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChatWindow',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(UITextXsRegular), null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('sidebar.chatWindowHelper')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(_unref(UIDivider)),
                _createVNode(_unref(UICollapse), {
                    arrowPlacement: 'left',
                    displayDirective: 'if'
                }, {
                    default: _withCtx(() => {
                        var _a, _b, _c, _d;
                        return [
                            _createVNode(_unref(UICollapseItem), {
                                title: _ctx.$t('sidebar.titleAndIntro'),
                                name: "1",
                                id: "1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(TitleAndIntro)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["title"]),
                            (((_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.chatType) === _unref(ChatType).LIVE_CHAT)
                                ? (_openBlock(), _createBlock(_unref(UICollapseItem), {
                                    key: 0,
                                    title: _ctx.$t('sidebar.liveChatAssigned'),
                                    name: "2",
                                    id: "2"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(LiveChatAssigned)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"]))
                                : _createCommentVNode("v-if", true),
                            (((_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.chatType) === _unref(ChatType).WA_CHAT)
                                ? (_openBlock(), _createBlock(_unref(UICollapseItem), {
                                    key: 1,
                                    title: _ctx.$t('sidebar.whatsappSettings'),
                                    name: "3",
                                    id: "3"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(WhatsappSettings)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"]))
                                : _createCommentVNode("v-if", true),
                            (((_c = _unref(appState).chatWidgetSettingsData) === null || _c === void 0 ? void 0 : _c.chatType) === _unref(ChatType).LIVE_CHAT)
                                ? (_openBlock(), _createBlock(_unref(UICollapseItem), {
                                    key: 2,
                                    title: _ctx.$t('sidebar.liveChatClosed'),
                                    name: "4",
                                    id: "4"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(LiveChatClosed)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"]))
                                : _createCommentVNode("v-if", true),
                            (((_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.chatType) === _unref(ChatType).LIVE_CHAT &&
                                _unref(appState).levelUpCompany)
                                ? (_openBlock(), _createBlock(_unref(UICollapseItem), {
                                    key: 3,
                                    title: _ctx.$t('sidebar.businessOfficeHourSetup'),
                                    name: "5",
                                    id: "5"
                                }, {
                                    "header-extra": _withCtx(() => [
                                        _createVNode(_unref(UITag), {
                                            closable: false,
                                            size: "small",
                                            round: true,
                                            bordered: true,
                                            type: "warning"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(" New ")
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    default: _withCtx(() => [
                                        _createVNode(BusinessOfficeHourSetup)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"]))
                                : _createCommentVNode("v-if", true),
                            _createVNode(_unref(UICollapseItem), {
                                title: _ctx.$t('sidebar.additionalOptions'),
                                name: "6",
                                id: "6"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(AdditionalOptions)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["title"])
                        ];
                    }),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
